<template>
  <div
    class="surveyContainer"
    :style="{ height: isQuickStart ? 'calc(100vh - 48px)' : '100vh' }"
    :class="{ 'mt-12': isQuickStart }"
  >
    <v-row
      class="surveyContent justify-space-between"
      :class="{ mobileSurveyContent: isMobileSized }"
    >
      <v-col
        :cols="isMobileSized ? 12 : 5"
        class="d-flex px-10"
        style="position:relative;"
        :class="isMobileSized ? 'mt-16' : 'align-center'"
        :style="isMobileSized ? '' : 'height:100%;'"
      >
        <div :class="{ mobileDisplayContainer: isMobileSized }">
          <StepIcons :currentView="'survey'" :isMobileSized="isMobileSized" />
          <v-row no-gutters align="center" :style="isMobileSized ? '' : 'height:54vh'">
            <div v-if="isQuickStart">
              <div
                class="text-h4 font-weight-bold surveyTitle"
                :class="{ mobileTitle: isMobileSized }"
              >
                Quick Start: Survey
              </div>
              <p
                class="largeDescriptionText"
                :class="isMobileSized ? 'mobileDescriptionText mt-2' : 'mt-6'"
              >
                Please start by telling us a bit about yourself and what you're trying to advertise.
              </p>
            </div>
            <div v-else>
              <div
                class="text-h4 font-weight-bold surveyTitle"
                :class="{ mobileTitle: isMobileSized }"
              >
                Start Serving Ads for Free
              </div>
              <p
                class="largeDescriptionText"
                :class="isMobileSized ? 'mobileDescriptionText mt-2' : 'mt-6'"
              >
                Let's get started! Our goal is to help you get set up and start serving ads for free
                - no credit card required!
              </p>
              <p v-if="!isMobileSized" class="largeDescriptionText">
                We'll start simple and help guide you through creating your first ads. Afterwards,
                if you'd like, you can dive deeper into the platform and try more advanced features.
              </p>
              <p
                v-if="!isMobileSized"
                class="largeDescriptionText"
                :class="{ mobileDescriptionText: isMobileSized }"
              >
                Please start by telling us a bit about yourself and what you're trying to advertise.
              </p>
            </div>
          </v-row>
        </div>
      </v-col>
      <v-col
        align-self="center"
        class="d-flex justify-center surveyScroll"
        :class="{ 'px-4': isMobileSized }"
        style="background-color: rgb(94, 0, 235);"
        :style="
          isMobileSized
            ? 'padding-bottom: 166px; justify-content: center;'
            : `height:${isQuickStart ? 'calc(100vh - 48px)' : '100vh'}; margin-right: 14px;`
        "
      >
        <div :style="isMobileSized ? '' : 'margin-top: 58px; overflow: auto; height: 83%;'">
          <div v-if="!isQuickStart">
            <div
              class="white--text font-weight-bold text-center surveyQuestion"
              :class="{ mobileQuestion: isMobileSized }"
              >Are you self-promoting, or are you advertising on behalf of clients?</div
            >
            <div class="d-flex justify-center font-weight-bold wrapContent">
              <div
                v-for="advertiser in advertiserTypes"
                :key="advertiser.name"
                class="mt-3 text-center surveyButton"
                :class="{
                  selected: advertiserType.name === advertiser.name,
                  mobileButton: isMobileSized,
                }"
                @click="handleAdvertiserSelect(advertiser)"
              >
                <div>{{ advertiser.name }}</div>
                <v-icon>{{ advertiser.icon }}</v-icon>
              </div>
            </div>
            <div
              ref="verticalQuestion"
              class="mt-6 white--text font-weight-bold text-center surveyQuestion"
              :class="{ mobileQuestion: isMobileSized }"
              >What kind of business?</div
            >
          </div>
          <div v-else class="mt-6 white--text font-weight-bold text-center"
            >What kind of business are you advertising?</div
          >
          <div class="d-flex justify-center font-weight-bold wrapContent">
            <div
              v-for="businessType in businessTypes"
              :key="businessType.name"
              class="text-center surveyButton verticalButton mt-3"
              :class="{
                selected: businessType.name === vertical.name,
                mobileButton: isMobileSized,
              }"
              @click="handleVerticalSelect(businessType)"
            >
              <div>{{ businessType.name }}</div>
              <v-icon>{{ businessType.icon }}</v-icon>
            </div>
          </div>
          <div v-if="vertical.name" class="mb-5">
            <div
              ref="adTypeQuestion"
              class="mt-6 white--text font-weight-bold text-center surveyQuestion"
              :class="{ mobileQuestion: isMobileSized }"
              >What would you like to advertise?</div
            >
            <div class="d-flex justify-center font-weight-bold wrapContent pb-3">
              <div
                v-for="ad in adTypes"
                :key="ad.name"
                class="text-center surveyButton adButton mt-3"
                :class="{ selected: adType.name === ad.name, mobileButton: isMobileSized }"
                @click="
                  guibus_publish('dispatch:beacon', {
                    eventId: `welcome-survey_slide_ad_type_${ad.logValue}-click${
                      isMobileSized ? '-mobile' : ''
                    }`,
                  })
                  adType = ad
                "
              >
                <div>{{ ad.name }}</div>
                <v-icon dense>{{ ad.icon }}</v-icon>
              </div>
            </div>
          </div>
        </div>
        <div class="backNextButtonDisplay" :class="{ mobileBackNextButtonDisplay: isMobileSized }">
          <v-btn
            v-if="!isQuickStart"
            class="mr-3"
            dark
            color="grey lighten-1"
            @click="
              guibus_publish('dispatch:beacon', {
                eventId: `welcome-survey_slide_back_button-click${isMobileSized ? '-mobile' : ''}`,
              })
              $emit('stepBack', 'intro')
            "
            >Back</v-btn
          >
          <v-btn
            :disabled="isNextStepDisabled"
            class="white--text"
            color="primary"
            @click="saveAndContinue"
            >Next</v-btn
          >
        </div>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import StepIcons from '../units/StepIcons'

export default {
  props: {
    currentSurveyData: {
      type: Object,
      default: undefined,
    },
    isQuickStart: {
      type: Boolean,
      default: false,
    },
    isMobileSized: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    StepIcons,
  },
  data() {
    return {
      advertiserTypes: [
        { name: 'Self-Promoting', icon: 'mdi-account', value: 'self' },
        { name: 'For Clients', icon: 'mdi-account-multiple-outline', value: 'agency' },
      ],
      businessTypes: [
        { name: 'Retail', icon: 'mdi-shopping', value: 'retail', logValue: 'retail' },
        { name: 'Auto', icon: 'mdi-car', value: 'auto', logValue: 'auto' },
        { name: 'Real Estate', icon: 'mdi-home', value: 'realestate', logValue: 'realestate' },
        { name: 'Hotel/Travel', icon: 'mdi-bag-suitcase', value: 'hotel', logValue: 'hotel' },
        { name: 'Service', icon: 'mdi-account', value: 'service', logValue: 'service' },
        { name: 'Other', icon: 'mdi-dots-horizontal', value: 'retail', logValue: 'other' },
      ],
      adTypes: undefined,
      verticalUseCases: [
        { name: 'A Store/ Brand', icon: 'mdi-store', value: 'static', logValue: 'storebrand' },
        { name: 'Offers/ Promotions', icon: 'mdi-map-marker', value: 'static', logValue: 'offers' },
        { name: 'Product Catalog', icon: 'mdi-basket', value: 'dynamic', logValue: 'products' },
        { name: 'Other', icon: 'mdi-dots-horizontal', value: 'static', logValue: 'other' },
      ],
      serviceSubVerticals: [
        {
          name: 'Home Improvement',
          icon: 'mdi-home-lightbulb',
          value: 'static',
          logValue: 'homeimprovement',
        },
        { name: 'Finance & Investment', icon: 'mdi-finance', value: 'static', logValue: 'finance' },
        {
          name: 'Real Estate',
          icon: 'mdi-sign-real-estate',
          value: 'static',
          logValue: 'realestate',
        },
        {
          name: 'Medical & Dental',
          icon: 'mdi-hospital-box',
          value: 'static',
          logValue: 'medical',
        },
        {
          name: 'Insurance',
          icon: 'mdi-shield-check-outline',
          value: 'static',
          logValue: 'insurance',
        },
        { name: 'Beauty', icon: 'mdi-lipstick', value: 'static', logValue: 'beauty' },
        { name: 'Health & Lifestyle', icon: 'mdi-dumbbell', value: 'static', logValue: 'health' },
        { name: 'Education', icon: 'mdi-school', value: 'static', logValue: 'education' },
        { name: 'Marketing', icon: 'mdi-bullhorn', value: 'static', logValue: 'marketing' },
        { name: 'Travel', icon: 'mdi-bag-suitcase', value: 'static', logValue: 'travel' },
        { name: 'Legal', icon: 'mdi-scale-balance', value: 'static', logValue: 'legal' },
        { name: 'Food & Beverage', icon: 'mdi-food', value: 'static', logValue: 'food' },
      ],
      advertiserType: {},
      vertical: {},
      adType: {},
    }
  },
  beforeMount() {
    this.advertiserType =
      this.currentSurveyData && !this.isQuickStart
        ? this.advertiserTypes.find(
            advertiser => advertiser.name === this.currentSurveyData.advertiserType.name
          )
        : {}
    this.vertical = this.currentSurveyData
      ? this.businessTypes.find(vertical => vertical.name === this.currentSurveyData.vertical.name)
      : {}
    this.adTypes =
      this.vertical.name === 'Service' ? this.serviceSubVerticals : this.verticalUseCases
    this.adType = this.currentSurveyData
      ? this.adTypes.find(adType => adType.name === this.currentSurveyData.adType.name)
      : {}
  },
  methods: {
    saveAndContinue() {
      this.guibus_publish('dispatch:beacon', {
        eventId: `welcome-survey_slide_next_button-click${this.isMobileSized ? '-mobile' : ''}`,
      })
      this.$emit('changeStep', { step: 'solutions', surveyData: this.surveyData })
    },
    handleAdvertiserSelect(advertiser) {
      this.guibus_publish('dispatch:beacon', {
        eventId: `welcome-survey_slide_advertiser_type_${advertiser.value}-click${
          this.isMobileSized ? '-mobile' : ''
        }`,
      })
      this.advertiserType = advertiser
      this.$refs.verticalQuestion.scrollIntoView({ behavior: 'smooth', block: 'start' })
    },
    handleVerticalSelect(businessType) {
      this.guibus_publish('dispatch:beacon', {
        eventId: `welcome-survey_slide_vertical_${businessType.logValue}-click${
          this.isMobileSized ? '-mobile' : ''
        }`,
      })
      this.vertical = businessType
      this.adType = {}
      this.$nextTick(() => {
        this.$refs.adTypeQuestion.scrollIntoView({ behavior: 'smooth', block: 'start' })
      })
    },
  },
  computed: {
    surveyData() {
      return {
        advertiserType: this.advertiserType,
        vertical: this.vertical,
        adType: this.adType,
      }
    },
    isNextStepDisabled() {
      return (
        (!this.isQuickStart && !this.advertiserType.value) ||
        !this.vertical.value ||
        !this.adType.value
      )
    },
  },
  watch: {
    vertical() {
      this.adTypes =
        this.vertical.name === 'Service' ? this.serviceSubVerticals : this.verticalUseCases
    },
  },
}
</script>

<style lang="scss" scoped>
.surveyContainer {
  width: 100vw;
  height: 100%;
  .surveyContent {
    display: flex;
    height: 100%;
    position: relative;
    width: 100%;
    margin: auto;
    align-items: center;
    &.mobileSurveyContent {
      height: unset;
    }
    .surveyScroll {
      &::-webkit-scrollbar {
        width: 12px;
        height: 12px;
      }

      &::-webkit-scrollbar-track {
        background: #e6e6e6;
        border-left: 1px solid #dadada;
      }

      &::-webkit-scrollbar-thumb {
        background: #b0b0b0;
        border: solid 3px #e6e6e6;
        border-radius: 7px;
      }
    }
  }
}
.surveyTitle {
  &.mobileTitle {
    font-size: 1.5rem !important;
  }
}
.surveyQuestion {
  &.mobileQuestion {
    font-size: 14px;
  }
}
.surveyButton {
  line-height: 1;
  color: black;
  width: 133px;
  height: 80px;
  border: 1px solid white;
  border-radius: 10px;
  background-color: white;
  margin: 0 10px;
  padding: 10px;
  box-shadow: 0 8px 16px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
  font-size: 14px;
  &:hover {
    background-color: #f5f5f5;
  }
  cursor: pointer;
  .v-icon {
    font-size: 40px;
  }
  &.selected {
    background-color: #bbdefb;
  }
  &.mobileButton {
    font-size: 12px;
    width: 94px;
    height: 66px;
    .v-icon {
      font-size: 28px;
    }
  }
}
.wrapContent {
  flex-wrap: wrap;
}
.mobileDisplayContainer {
  position: relative;
}
.backNextButtonDisplay {
  position: absolute;
  bottom: 32px;
  right: 140px;
  &.mobileBackNextButtonDisplay {
    position: fixed;
    bottom: 90px;
    left: 0;
    width: 100%;
    display: flex;
    justify-content: center;
    z-index: 10;
  }
}
</style>
